import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Spinner extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      isLoading : this.props.isLoading
    }

    this.config = { 
      types : [],
      modifiers : [
        {
          title: 'default',
          isDefault: true,
        }, 
        'inverse'
      ],
      states : []
    }
  }
  
  render() {
    const props = clearProps(this.props)
    return  ( 
      this.state.isLoading ? <div {...props} className={resolveProps(this.props, this.config,'Spinner')}>
      <span className="mdn-Icon-claro mdn-Icon--lg" />
    </div> : ''
    )
  }
}

Spinner.propTypes = {
  config : PropTypes.object,
}